import gql from 'graphql-tag';

export const presentationQueryViewerWithSymbols = gql`
  query presentation($identifier: String!, $password: String) {
    presentation(identifier: $identifier, password: $password) {
      id
      name
      updatedAt
      publishedAt
      canClone
      canDownload
      visible
      hideControls
      scrollableViewer
      slides {
        edges {
          node {
            id
            updatedAt
            hashmapContent
            transition {
              id
              params {
                duration
              }
            }
            media {
              id
              remoteUrl
              mimeType
            }
          }
        }
      }
      fonts {
        id
        name
        type
        variants {
          weight
          style
          url
          name
        }
      }
      symbols {
        id
        name
        content
      }
      user {
        id
        name
        planInfo {
          basic
        }
      }
      team {
        id
        name
        planInfo {
          basic
        }
        domains {
          customDomain
        }
      }
    }
  }
`;

export const presentationQueryViewerWithoutSymbols = gql`
  query presentation($identifier: String!, $password: String) {
    presentation(identifier: $identifier, password: $password) {
      id
      name
      updatedAt
      publishedAt
      canClone
      canDownload
      visible
      hideControls
      scrollableViewer
      slides {
        edges {
          node {
            id
            updatedAt
            hashmapContent
            transition {
              id
              params {
                duration
              }
            }
            media {
              id
              remoteUrl
              mimeType
            }
          }
        }
      }
      fonts {
        id
        name
        type
        variants {
          weight
          style
          url
          name
        }
      }
      user {
        name
        planInfo {
          basic
        }
      }
      team {
        name
        planInfo {
          basic
        }
        domains {
          customDomain
        }
      }
    }
  }
`;

export const presentationQueryOffline = gql`
  query presentation($identifier: String!, $password: String) {
    presentation(identifier: $identifier, password: $password) {
      id
      updatedAt
      canClone
      canDownload
      scrollableViewer
      hideControls
      slides {
        edges {
          node {
            id
            hashmapContent
            transition {
              duration
              ease {
                type
                curve
              }
              enter {
                from
                to
              }
              exit {
                from
                to
              }
            }
            media {
              id
              remoteUrl
              mimeType
            }
          }
        }
      }
      fonts {
        id
        name
        type
        variants {
          weight
          style
          url
          name
        }
      }
      symbols {
        id
        name
        content
      }
      user {
        name
      }
      team {
        name
        planInfo {
          basic
        }
      }
    }
    me {
      planInfo {
        basic
      }
    }
  }
`;

export const presentationQueryPDF = gql`
  query presentation($identifier: String!, $password: String) {
    presentation(identifier: $identifier, password: $password) {
      name
      canDownload
      slides {
        edges {
          node {
            hashmapContent
          }
        }
      }
      fonts {
        id
        name
        type
        variants {
          weight
          style
          url
          name
        }
      }
      symbols {
        id
        name
        content
        version
      }
      user {
        id
      }
    }
  }
`;

export const presentationQueryMigrate = gql`
  query presentation($identifier: String!, $password: String) {
    presentation(identifier: $identifier, password: $password) {
      slides {
        edges {
          node {
            id
            hash
            hashmapContent
            visible
            notes
            transition {
              id
              params {
                duration
              }
            }
            templateId
            templateHash
          }
        }
      }
    }
  }
`;

export const featuredFontsQuery = gql`
  query featuredFontsQuery($teamId: UUID) {
    featuredFonts(teamId: $teamId) {
      edges {
        node {
          id
          name
          type
          variants {
            weight
            style
            name
            url
          }
          author
          authorUrl
          previewUrl
          visualUrl
          highlighted
          added
        }
      }
    }
  }
`;

export const myBlocksQuery = gql`
  query {
    me {
      id
      blocks {
        id
        code
        name
        type
        description
        thumbnail
        icon
        tags {
          edges {
            tag: node {
              id
              name
            }
          }
        }
        content
        version
      }
    }
  }
`;

export const ourBlocksQuery = gql`
  query ourBlocksQuery($id: UUID!) {
    us(id: $id) {
      id
      blocks {
        id
        code
        name
        type
        description
        thumbnail
        icon
        tags {
          edges {
            tag: node {
              id
              name
            }
          }
        }
        content
        version
      }
    }
  }
`;

export const me = gql`
  query {
    me {
      id
      name
      avatar
      teams {
        edges {
          team: node {
            id
            name
            avatar
          }
        }
      }
    }
  }
`;

export const socialsQuery = gql`
  query {
    me {
      id
      socials {
        id
        provider
        uid
        extraData
      }
    }
  }
`;
